const avtoPathesHead = {
  make: (data, p) => ({
    header: `Квадроциклы ${data.make}`,
    header_uk: `Квадроцикли ${data.make}`,

    title: `Квадроциклы ${data.makeTranslit} в Украине, купить квадроцикл ${data.make} бу или новый - Автобазар`,
    title_uk: `Квадроцикли ${data.makeTranslit} в Україні, купити квадроцикл ${data.make} бу або новий - Автобазар`,

    description: `Купить квадроцикл ${data.make} с пробегом или новый ⭐ Цены на квадроциклы, характеристики и фото на сайте Автобазар`,
    description_uk: `Купити квадроцикл ${data.make} з пробігом або новий ⭐ Ціни на квадроцикли, характеристики та фото на сайті Автобазар`,
  }),
  city: (data, p) => ({
    title: `Купить квадроцикл бу ${p.inCity} с пробегом недорого - Автобазар`,
    title_uk: `Купити квадроцикл бу ${p.inCity} з пробігом недорого - Автобазар`,

    description: `Продажа квадроциклов бу ${p.t(
      data.city,
    )}. Купить квадроцикл бу ${p.inCity} с пробегом на Автобазар. Подержанные квадроциклы от проверенных продавцов. Большой выбор объявлений. Выгодная цена`,
    description_uk: `Продаж квадроциклів бу ${p.t(
      data.city,
    )}. Купити квадроцикл бу ${p.inCity} з пробігом на Автобазар. Вживані квадроцикли від перевірених продавців. Великий вибір оголошень. Вигідна ціна`,
  }),
  body: (data, p) => ({
    header: `${p.buy} ${p.t(data.body).toLowerCase()} квадроцикл бу`,
  }),

  makeModel: (data, p) => ({
    header: `${p.buy} квадроцикл ${data.make} ${data.model} бу`,

    title: `Купить квадроцикл ${data.make} ${data.model} бу в Украине недорого - Автобазар`,
    title_uk: `Купити квадроцикл ${data.make} ${data.model} бу в Україні недорого - Автобазар`,

    description: `Продажа квадроциклов ${data.make} ${data.model} бу в Украине. Купить квадроцикл ${data.make} ${data.model} бу с пробегом недорого на Автобазар. Подержанные квадроциклы от проверенных продавцов. Большой выбор объявлений`,
    description_uk: `Продаж квадроциклів ${data.make} ${data.model} бу в Україні. Купити квадроцикл ${data.make} ${data.model} бу з пробігом недорого на Автобазар. Вживані квадроцикли від перевірених продавців. Великий вибір оголошень`,
  }),
  makeCity: (data, p) => ({
    title: `Купить квадроцикл ${data.make} бу ${p.inCity} - Автобазар`,
    title_uk: `Купити квадроцикл ${data.make} бу ${p.inCity} - Автобазар`,

    description: `Продажа квадроциклов ${data.make} бу ${p.t(
      data.city,
    )}. Купить квадроцикл ${data.make} бу с пробегом на Автобазар. Большой выбор объявлений ${p.inCity}. Сравнить цены, посмотреть фото`,
    description_uk: `Продаж квадроциклів ${data.make} бу ${p.t(
      data.city,
    )}. Купити квадроцикл ${data.make} бу з пробігом на Автобазар. Великий вибір оголошень ${p.inCity}. Порівняти ціни, подивитися фото`,
  }),
  cityIsnew: (data, p) => ({
    title: `Купить квадроцикл новый ${p.inCity} недорого - Автобазар`,
    title_uk: `Купити квадроцикл новий ${p.inCity} недорого - Автобазар`,
    description: `Купить квадроцикл новый ${p.inCity} недорого на Автобазар. Большой выбор объявлений. Сравнить цены в мотосалонах и от частных продавцов`,
    description_uk: `Купити квадроцикл новий ${p.inCity} недорого на Автобазар. Великий вибір оголошень. Порівняти ціни в мотосалонах і від приватних продавців`,
  }),
  makeIsnew: (data, p) => ({
    title: `Купить квадроцикл ${data.make} новый в Украине недорого - Автобазар`,
    title_uk: `Купити квадроцикл ${data.make} новий в Україні недорого - Автобазар`,
    description: `Купить квадроцикл ${data.make} новый недорого на Автобазар. Большой выбор объявлений. Сравнить цены в мотосалонах и от частных продавцов`,
    description_uk: `Купити квадроцикл ${data.make} новий недорого на Автобазар. Великий вибір оголошень. Порівняти ціни в мотосалонах і від приватних продавців`,
  }),
  makeBody: (data, p) => ({
    header: `${p.buy} ${p.t(data.body).toLowerCase()} квадроцикл ${data.make} бу`,
  }),
  bodyIsnew: (data, p) => ({
    header: `Купить новый ${p.t(data.body).toLowerCase()} квадроцикл`,
    header_uk: `Купити новий ${p.t(data.body).toLowerCase()} квадроцикл`,
  }),
  bodyCity: (data, p) => ({
    header: `${p.buy} ${p.t(data.body).toLowerCase()} квадроцикл бу ${p.inCity}`,
  }),

  makeModelCity: (data, p) => ({
    header: `${p.buy} квадроцикл ${data.make} ${data.model} бу ${p.inCity}`,

    title: `Купить квадроцикл ${data.make} ${data.model} бу ${p.inCity} - Автобазар`,
    title_uk: `Купити квадроцикл ${data.make} ${data.model} бу ${p.inCity} - Автобазар`,

    description: `Продажа квадроциклов ${data.make} ${data.model} бу ${p.t(
      data.city,
    )}. Купить квадроцикл ${data.make} ${data.model} бу с пробегом на Автобазар. Большой выбор объявлений ${p.inCity}. Сравнить цены, посмотреть фото`,
    description_uk: `Продаж квадроциклів ${data.make} ${data.model} бу ${p.t(
      data.city,
    )}. Купити квадроцикл ${data.make} ${data.model} бу з пробігом на Автобазар. Великий вибір оголошень ${p.inCity}. Порівняти ціни, подивитися фото`,
  }),
  makeModelIsnew: (data, p) => ({
    header: `Купить новый квадроцикл ${data.make} ${data.model}`,
    header_uk: `Купити новий квадроцикл ${data.make} ${data.model}`,

    title: `Купить квадроцикл ${data.make} ${data.model} новый в Украине недорого - Автобазар`,
    title_uk: `Купити квадроцикл ${data.make} ${data.model} новий в Україні недорого - Автобазар`,

    description: `Купить квадроцикл ${data.make} ${data.model} новый в Украине недорого на Автобазар. Большой выбор объявлений. Сравнить цены в мотосалонах и от частных продавцов`,
    description_uk: `Купити квадроцикл ${data.make} ${data.model} новий в Україні недорого на Автобазар. Великий вибір оголошень. Порівняти ціни в мотосалонах і від приватних продавців`,
  }),
  makeCityIsnew: (data, p) => ({
    title: `Купить квадроцикл ${data.make} новый ${p.inCity} - Автобазар`,
    title_uk: `Купити квадроцикл ${data.make} новий ${p.inCity} - Автобазар`,
    description: `Купить квадроцикл ${data.make} новый ${p.inCity} на Автобазар. Большой выбор объявлений. Сравнить цены в мотосалонах и от частных продавцов`,
    description_uk: `Купити квадроцикл ${data.make} новий ${p.inCity} на Автобазар. Великий вибір оголошень. Порівняти ціни в мотосалонах і від приватних продавців`,
  }),
  makeModelBody: (data, p) => ({
    header: `Купить ${p.t(data.body).toLowerCase()} квадроцикл ${data.make} ${data.model} бу`,
    header_uk: `Купити ${p.t(data.body).toLowerCase()} квадроцикл ${data.make} ${data.model} бу`,
  }),
  makeModelYear: (data, p) => ({
    header: `Купить квадроцикл ${data.make} ${data.model} ${data.year} года бу`,
    header_uk: `Купити квадроцикл ${data.make} ${data.model} ${data.year} року бу`,
  }),
  isnewMakeBody: (data, p) => ({
    header: `Купить новый ${p.t(data.body).toLowerCase()} квадроцикл ${data.make}`,
    header_uk: `Купити новий ${p.t(data.body).toLowerCase()} квадроцикл ${data.make}`,
  }),
  makeCityBody: (data, p) => ({
    header: `${p.buy} ${p.t(data.body).toLowerCase()} квадроцикл ${data.make} бу ${p.inCity}`,
  }),
  isnewBodyCity: (data, p) => ({
    header: `Купить новый ${p.t(data.body).toLowerCase()} квадроцикл ${p.inCity}`,
    header_uk: `Купити новий ${p.t(data.body).toLowerCase()} квадроцикл ${p.inCity}`,
  }),

  isnewMakeModelYear: (data, p) => ({
    header: `Купить новый квадроцикл ${data.make} ${data.model} ${data.year} года`,
    header_uk: `Купити новий квадроцикл ${data.make} ${data.model} ${data.year} року`,

    title: `Купить квадроцикл ${data.make} ${data.model} ${data.year} новый в Украине - Автобазар`,
    title_uk: `Купити квадроцикл ${data.make} ${data.model} ${data.year} новий в Україні - Автобазар`,
    description: `Купить квадроцикл ${data.make} ${data.model} ${data.year} новый на Автобазар. Большой выбор объявлений. Сравнить цены в мотосалонах и от частных продавцов`,
    description_uk: `Купити квадроцикл ${data.make} ${data.model} ${data.year} новий на Автобазар. Великий вибір оголошень. Порівняти ціни в мотосалонах і від приватних продавців`,
  }),
  isnewMakeModelCity: (data, p) => ({
    header: `Купить новый квадроцикл ${data.make} ${data.model} ${p.inCity}`,
    header_uk: `Купити новий квадроцикл ${data.make} ${data.model} ${p.inCity}`,

    title: `Купить квадроцикл ${data.make} ${data.model} новый ${p.inCity} - Автобазар`,
    title_uk: `Купити квадроцикл ${data.make} ${data.model} новий ${p.inCity} - Автобазар`,
    description: `Купить квадроцикл ${data.make} ${data.model} новый ${p.inCity} на Автобазар. Большой выбор объявлений. Сравнить цены в мотосалонах и от частных продавцов`,
    description_uk: `Купити квадроцикл ${data.make} ${data.model} новий ${p.inCity} на Автобазар. Великий вибір оголошень. Порівняти ціни в мотосалонах і від приватних продавців`,
  }),
  isnewMakeModelBody: (data, p) => ({
    header: `Купить новый ${p.t(data.body).toLowerCase()} квадроцикл ${data.make} ${data.model}`,
    header_uk: `Купити новий ${p.t(data.body).toLowerCase()} квадроцикл ${data.make} ${data.model}`,
  }),
  makeModelCityBody: (data, p) => ({
    header: `Купить ${p
      .t(data.body)
      .toLowerCase()} квадроцикл ${data.make} ${data.model} бу ${p.inCity}`,
    header_uk: `Купити ${p
      .t(data.body)
      .toLowerCase()} квадроцикл ${data.make} ${data.model} бу ${p.inCity}`,
  }),
  isnewMakeCityBody: (data, p) => ({
    header: `Купить новый ${p.t(data.body).toLowerCase()} квадроцикл ${data.make} ${p.inCity}`,
    header_uk: `Купити новий ${p.t(data.body).toLowerCase()} квадроцикл ${data.make} ${p.inCity}`,
  }),

  isnewMakeModelCityBody: (data, p) => ({
    header: `Купить новый ${p
      .t(data.body)
      .toLowerCase()} квадроцикл ${data.make} ${data.model} ${p.inCity}`,
    header_uk: `Купити новий ${p
      .t(data.body)
      .toLowerCase()} квадроцикл ${data.make} ${data.model} ${p.inCity}`,
  }),
};

export default avtoPathesHead;



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/search/kvadrotsikl/templates.js